import { getConsentId } from './model/get-consent-id'
import { ConsentProviderPort } from '../ports'
import { OneTrust } from './model/onetrust'

export class OnetrustConsentProvider implements ConsentProviderPort {
  constructor(private readonly oneTrust: OneTrust) {}

  OnConsentChanged(callback: () => void): void {
    this.oneTrust.OnConsentChanged(callback)
  }

  getConsentId(): null | string {
    return getConsentId()
  }
}
